export enum TransactionTypeEnum {
    Compra = 1,
    Venda = 2
}

export const transactionTypeOptionList = 
     Object.keys(TransactionTypeEnum)
    .filter((key) => isNaN(Number(key)))
    .map((key) => ({
        label: key,
        value: TransactionTypeEnum[key as keyof typeof TransactionTypeEnum]
    }));